import { Format } from "@cardheim/types";

export const formatHasLeadership = (format: Format) => {
	return [
		Format.COMMANDER,
		Format.PAUPER_COMMANDER,
		Format.BRAWL,
		Format.OATHBREAKER,
	].includes(format);
};

export const leadershipByFormat = (format: string) => {
	switch (format) {
		case Format.COMMANDER:
			return {
				value: "commander",
				label: "Commander",
			};

		case Format.PAUPER_COMMANDER:
			return {
				value: "paupercommander",
				label: "Commander",
			};
		case Format.BRAWL:
			return {
				value: "brawler",
				label: "Brawler",
			};
		case Format.OATHBREAKER:
			return {
				value: "oathbreaker",
				label: "Oathbreaker",
			};
		default:
			return null;
	}
};
